import { render, staticRenderFns } from "./EditLevelLeaderBoardDialog.vue?vue&type=template&id=587bf30d&scoped=true"
import script from "./EditLevelLeaderBoardDialog.vue?vue&type=script&lang=js"
export * from "./EditLevelLeaderBoardDialog.vue?vue&type=script&lang=js"
import style0 from "./EditLevelLeaderBoardDialog.vue?vue&type=style&index=0&id=587bf30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587bf30d",
  null
  
)

export default component.exports